var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInaccurate1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_4482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 7.33325L10.0002 9.99992M10.0002 9.99992L7.3335 12.6666M10.0002 9.99992L7.3335 7.33325M10.0002 9.99992L12.6668 12.6666M7.24016 3.33325H12.7602L16.6668 7.23992V12.7599L12.7602 16.6666H7.24016L3.3335 12.7599V7.23992L7.24016 3.33325Z",
    stroke: "#220046",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInaccurate1);
export default __webpack_public_path__ + "static/media/Inaccurate1.455ec3a5d2128b5b5b68a262d6447a1e.svg";
export { ForwardRef as ReactComponent };